import React, { useState, useEffect} from 'react';
import c from 'classnames';

import {
  WysiwygField,
  FormattedLink,
  FullWidthImage,
} from '../../../components';

import ParagraphText from '../Text';

import './style.scss';

const ParagraphTextImage = ({ entity, className, withIndent }) => {

  const imagePostion = entity.getIn(['field_image_position', 0, 'value']);
  const link = entity.get('field_link');
  const isVerticalLayout = imagePostion === 'top' || imagePostion.includes('bottom');


  // Check if we have an image and switch to
  // a paragraph without an image if needed.
  if (entity.get('field_image').size < 1) {
    return <ParagraphText entity={entity} />;
  }

  return (
    <div className={c('Paragraph', 'ParagraphTextImage', { 'u-indent': withIndent }, className)} data-is-vertical-layout={isVerticalLayout} data-image-position={imagePostion}>
      <div className={c('row', { 'u-flipped--reversed': imagePostion === 'right' }, {'flex-column-reverse': imagePostion === 'bottom' || imagePostion === 'bottom_buttons'})}>
        {entity.get('field_text').size > 0 ? (
          <div className={c(!isVerticalLayout && 'col-md-6', 'content', !isVerticalLayout && 'offset-md-1', {'u-margin--top--5': imagePostion === "top"}, 'js-parallax', { 'offset-lg-0': imagePostion === 'right' }, (imagePostion === 'bottom' || imagePostion === 'bottom_buttons') && 'u-margin--bottom--5', {'col-md-10': isVerticalLayout}, {'mx-auto': isVerticalLayout}, (imagePostion === 'bottom' || imagePostion === 'bottom_buttons') && 'u-margin--bottom--5')}>
            <h2>{entity.getIn(['field_title', 0, 'value'])}</h2>
            <WysiwygField
              property="schema:text"
              html={entity.getIn(['field_text', 0, 'processed'])}
            />
            {imagePostion !== 'bottom_buttons' && (
              <FormattedLink link={link} />
            )}
          </div>
        ) : (
          <div className="col-md-12">
            <h2>{entity.getIn(['field_title', 0, 'value'])}</h2>
          </div>
        )}
        {imagePostion === 'bottom_buttons' && (
          <div class="mx-auto">
            <FullWidthImage entity={entity} imagePostion={imagePostion} isVerticalLayout={isVerticalLayout} />
            {imagePostion === 'bottom_buttons' && (
              <div className={c('ParagraphTextImage__bottom-buttons', 'u-margin-top--1', 'mx-auto', 'col-10')}>
                <FormattedLink link={link} />
              </div>
            )}
          </div>
        )}
        {imagePostion !== 'bottom_buttons' && <FullWidthImage entity={entity} imagePostion={imagePostion} isVerticalLayout={isVerticalLayout} />}
      </div>
    </div>
  );
};

export default ParagraphTextImage;
